import type { components } from '@copilot/shared-types';
import { httpClient } from '../../shared/http/client';
import type { DashboardPeriod } from '../../shared/data/queryKeys';

export type DashboardRanking = components['schemas']['DashboardRanking'];
export type RankingMetric = 'meetings' | 'followups' | 'avg_sentiment';

export async function getRanking(
  metric: RankingMetric,
  period: DashboardPeriod,
): Promise<DashboardRanking> {
  const response = await httpClient.get<DashboardRanking>('/api/v1/dashboard/ranking', {
    params: { metric, period },
  });
  return response.data;
}
